import { trpc } from '@/lib/trpc';

/**
 * Hook for fetching dashboard statistics with real-time polling.
 *
 * Follows established pattern from useBinStatus and useCatcherStats.
 */
export function useDashboard(locationId: string | undefined) {
  return trpc.productionOrders.getDashboardStats.useQuery(
    { locationId: locationId! },
    {
      enabled: !!locationId,
      refetchInterval: 30_000,              // Poll every 30s
      refetchIntervalInBackground: false,   // Pause when tab hidden (battery/performance)
      staleTime: 15_000,                    // Consider fresh for 15s
      structuralSharing: true,              // Only re-render if data actually changed
    }
  );
}
